'use strict';

var Entry = Backbone.Model.extend({
    defaults: {
        text: '',
        url: '',
        icon: '',
        entry_id: '',
        active: false,

        subs: [],
    },
});

var EntryCollection = Backbone.Collection.extend({
    model: Entry,
});

module.exports = {
    Model: Entry,
    Collection: EntryCollection,
};
